import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface VideoEditorEmbedProps {
  projectId?: string;
  src?: string;
  style?: React.CSSProperties;
  url?: string;
  overlayData?: any[];
  editor?: boolean;
  setUpdatedOverlays?: (overlays: any[]) => void;
  setUpdatedDuration?: (duration: string) => void;
}

const AllowedBaseURL = process.env.REACT_APP_ALLOWED_BASE_URL || '';

const ALLOWED_ORIGINS = [AllowedBaseURL,'http://192.168.100.164:3000','http://localhost:3001','http://localhost:3000', 'https://dev-editor.showcasaai.io', 'http://localhost:3000'];
console.log("ALLOWED_ORIGINS", ALLOWED_ORIGINS)

// const DEFAULT_SRC = 'http://localhost:3000/video-editor?playerOnly=true';
// const DEFAULT_SRC = 'http://localhost:3000/video-editor?playerOnly=true';
const DEFAULT_SRC = `${AllowedBaseURL}video-editor?playerOnly=true`;
console.log("DEFAULT_SRC", DEFAULT_SRC)


const VideoEditorEmbed: React.FC<VideoEditorEmbedProps> = ({
  projectId = 'test',
  src = DEFAULT_SRC,
  style = {},
  url = '',
  overlayData,
  editor = false,
  setUpdatedOverlays,
  setUpdatedDuration
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const location = useLocation();

  console.log('overlayDatasss',overlayData)

  // Print state from routing URL if present
  useEffect(() => {
    if (location.state?.data) {
      console.log('VideoEditorEmbed received location.state:', location.state?.data);
    }
  }, [location.state]);

  // Handshake: listen for READY_FOR_PROJECT_ID from iframe, then send projectId and overlays
  useEffect(() => {
    const handleHandshake = (event: MessageEvent) => {
      console.log('hiiiii', ALLOWED_ORIGINS, event.origin);
      if (!ALLOWED_ORIGINS.includes(event.origin)) return;
      console.log('hiiiidddddi', ALLOWED_ORIGINS, event.origin, event.data, event.data?.type);

      if (
        event.data &&
        typeof event.data === 'object' &&
        'type' in event.data &&
        event.data.type === 'READY_FOR_PROJECT_ID'
      ) {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          // Always send SET_PROJECT_ID first
          iframeRef.current.contentWindow.postMessage(
            { type: 'SET_PROJECT_ID', projectId },
            new URL(editor ? `${AllowedBaseURL}video-editor` : src).origin
          );
          // Then send overlays if present
          const videoUrl = location.state?.data?.videoUrl;
          const imageUrl = location.state?.data?.inputData?.imageUrl;
            const overlaysPayload = {
              type: 'SET_VIDEO_OVERLAYS',
              overlays: overlayData,
            };
            iframeRef.current.contentWindow.postMessage(overlaysPayload, new URL(editor ? `${AllowedBaseURL}video-editor` : src).origin);
            console.log('[VideoEditorEmbed] Sent overlays to child (after handshake):', overlaysPayload);
          // }
        }
      }
    };
    window.addEventListener('message', handleHandshake);
    return () => window.removeEventListener('message', handleHandshake);
  }, [projectId, src, location.state, url, overlayData]);

  // Send overlays to iframe whenever overlayData changes (after initial handshake)
  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      const overlaysPayload = {
        type: 'SET_VIDEO_OVERLAYS',
        overlays: overlayData,
      };
      iframeRef.current.contentWindow.postMessage(overlaysPayload, new URL(editor ? `${AllowedBaseURL}video-editor` : src).origin);
      console.log('[VideoEditorEmbed] Sent overlays to child (on overlayData change):', overlaysPayload);
    }
  }, [overlayData, src]);

  // Listen for messages from iframe
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!ALLOWED_ORIGINS.includes(event.origin)) return;
 if (event.data && typeof event.data === 'object' && event.data.type === 'UPDATE_OVERLAYS') {
        console.log('upadated[VideoEditorEmbed] Received UPDATE_OVERLAYS:', event.data);
        setUpdatedOverlays && setUpdatedOverlays(event.data.overlays);
        setUpdatedDuration && setUpdatedDuration(event.data);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={editor ? `${AllowedBaseURL}video-editor` : src}
      title="Video Editor"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
        ...style,
      }}
      allowFullScreen
    />
  );
};

export default VideoEditorEmbed;
 